import { Component, OnInit } from '@angular/core';
import { ProductosService } from "../../services/productos.service";
import { TranslateService } from 'ng2-translate';






@Component({
  selector: 'app-obras',
  templateUrl: './obras.component.html'
})
export class ObrasComponent implements OnInit {


  obrasMenu = [
    {
        titulo:'AVILÉS',
        subtitulo: 'Asturias',
        foto: 'assets/img/obras/aviles_plano.jpg',
        fotoC: 'assets/img/obras/aviles.jpg'
    },
    {
        titulo:'BENIDORM',
        subtitulo: 'Alicante',
        foto: 'assets/img/obras/benidorm_plano.jpg',
        fotoC: 'assets/img/obras/benidorm.jpg'
      },
      { //AVILES
      titulo:'CAPELLADES',
                subtitulo: 'Barcelona',
                foto: 'assets/img/obras/capellades_plano.jpg',
                fotoC: 'assets/img/obras/capellades.jpg'
            },
            { //AVILES
                titulo:'GIJÓN',
                subtitulo: 'Asturias',
                foto: 'assets/img/obras/gijon_plano.jpg',
                fotoC: 'assets/img/obras/gijon.jpg'
            },
            { //AVILES
                titulo:'LLANES',
                subtitulo: 'Asturias',
                foto: 'assets/img/obras/llanes_plano.jpg',
                fotoC: 'assets/img/obras/llanes.jpg'
            },
            { //AVILES
                titulo:'ORIO',
                subtitulo: 'Guipúzcoa',
                foto: 'assets/img/obras/orio_plano.jpg',
                fotoC: 'assets/img/obras/orio.jpg'
            },
            { //AVILES
                titulo:'PALENCIA',
                subtitulo: '',
                foto: 'assets/img/obras/palencia_plano.jpg',
                fotoC: 'assets/img/obras/palencia.jpg'
            },
            { //AVILES
                titulo:'RENTERÍA',
                subtitulo: 'Guipúzcoa',
                foto: 'assets/img/obras/renteria_plano.jpg',
                fotoC: 'assets/img/obras/renteria.jpg'
            },
            { //AVILES
                titulo:'SAN SEBASTIÁN',
                subtitulo: 'Guipúzcoa',
                foto: 'assets/img/obras/san_sebastian_plano.jpg',
                fotoC: 'assets/img/obras/san_sebastian.jpg'
            },
            { //AVILES
                titulo:'SIGÜENZA',
                subtitulo: 'Guadalajara',
                foto: 'assets/img/obras/siguenza_plano.jpg',
                fotoC: 'assets/img/obras/siguenza.jpg'
            }
          ];
  visibles = [{},{},{}];
  total = this.obrasMenu.length - 1;

  anterior = 0;
  actual:number = 0;
  siguiente = 0;
  iszoom = false;
  fotocolor:boolean = false;



  constructor( public _ps:ProductosService, private translate:TranslateService  ){}

  ngOnInit(){
    this.cambiaEstado(0);
  }

  retrocede = ()=> {
    if(this.actual == 0) {
      this.actual = this.total;
    }
    else {
      this.actual--;
    }
    this.cambiaEstado(this.actual);
    this.fotocolor = false;
  }

  avanza = ()=> {
    if(this.actual == this.total) {
      this.actual = 0;
    }
    else {
      this.actual++;
    }
    this.cambiaEstado(this.actual);
    this.fotocolor = false;
  }


  //FUNCIONES DE OBRAS//
  setActual = function (miActual) {
    this.actual = miActual;
  }

  setAnterior = function (miActual) {
        if (miActual > 0) this.anterior = miActual - 1;
        else this.anterior = this.total;
    }

  setSiguiente = function (miActual) {
        if (miActual < this.total) this.siguiente = miActual + 1;
        else this.siguiente = 0;
    }

  setVisibles = function () {
        this.visibles[0].index = this.anterior;
        this.visibles[0].clase = 'anterior';
        this.visibles[0].datos = this.obrasMenu[this.anterior];
        this.visibles[0].foto = this.obrasMenu[this.anterior].foto;
        this.visibles[0].onclick = this.cambiaEstado;

        this.visibles[1].index = this.actual;
        this.visibles[1].clase = 'actual';
        this.visibles[1].datos = this.obrasMenu[this.actual];
        this.visibles[1].foto = this.obrasMenu[this.actual].fotocolor;
        this.visibles[1].onclick = this.zoomActual;

        this.visibles[2].index = this.siguiente;
        this.visibles[2].clase = 'siguiente';
        this.visibles[2].datos = this.obrasMenu[this.siguiente];
        this.visibles[2].foto = this.obrasMenu[this.siguiente].foto;
        this.visibles[2].onclick = this.cambiaEstado;
    }

    zoomActual = function () {
        this.iszoom = !this.iszoom;
    }

    cambiaEstado = function(miActual) {
        this.setActual(miActual);
        this.setAnterior(miActual);
        this.setSiguiente(miActual);
        this.setVisibles();
        this.iszoom = false;
    }

    switchVista = function () {
        this.fotocolor = this.fotocolor===true? false: true;
    }



}



// WEBPACK FOOTER //
// /Users/administrador/Trabajos/pascal3/src/app/components/obras/obras.component.ts